export type OptionTab = keyof typeof optionTabs;

export const optionTabs = Object.freeze({
  DETAILS: 'DETAILS',
  ITEMS: 'ITEMS',
} as const);
